<template>
  <div>
    <div
      v-if="expandable"
      class="row clickable-row mb-2 non-selectable-text"
      @click="expanded = !expanded">
      <div class="col-10 text-left">
        <h3
          :class="{'font-weight-bold': boldName}"
          class="m-0">{{ office.name }}</h3>
      </div>
      <div class="col-2 chevron justify-content-end">
        <i :class="{'fas fa-chevron-up': expanded, 'fas fa-chevron-down': !expanded}"/>
      </div>
    </div>
    <div
      v-else
      class="row mt-3 mb-2">
      <div class="col-12 text-left">
        <h3
          :class="{'font-weight-bold': boldName}"
          class="m-0">{{ office.name }}</h3>
      </div>
    </div>
    <transition name="slide-y">
      <div
        v-if="expanded"
        class="office-information">
        <div v-if="office.address && office.address.city && !hideDetail">
          {{
            office.address.street +
              (office.address.appartment !== ""? ", " + office.address.appartment: "")
          }}
          <br>
          {{
            office.address.city +
              ", " + $t("PROVINCE." + office.address.provinceCode) +
              (office.address.postalCode !== ""? ", " + office.address.postalCode: "")
          }}
          <div class="fax-number">
            <span>{{ $t("PHONE_NUMBER_TYPE.FAX") + " " }}</span>
            <input
              v-mask="[' ### ###-####','# ### ###-####', '# ###  ###-#### !##########']"
              :value="getFaxOnly(office.phoneNumbers)"
              class="form-control-plaintext"
              disabled>
          </div>
        </div>
        <div
          v-for="(phone, index) in getPhoneOnly(office.phoneNumbers)"
          :key="index">
          <div class="pt-2 pb-2 pr-1 pl-1">
            <span v-if="getPhoneOnly(office.phoneNumbers).length > 1">{{ $t(phone.type) + " " }}</span>
            <a
              :href="'tel:' + phone.number"
              class="btn btn-lg btn-primary btn-block text-left phone-number">
              <i class="fas fa-phone mr-2"/>
              <input
                v-mask="[' ### ###-####','# ### ###-####', '# ###  ###-#### !##########']"
                :value="phone.number + phone.extension"
                class="form-control-plaintext phone-number"
                disabled>
            </a>
          </div>
        </div>
        <div class="">
          <a
            v-if="office.email"
            :href="'mailto:' + office.email"
            target="_blank"
            class="row mt-2">
            <div class="col-2 text-center"><i class="fas fa-envelope pr-2"/></div>
            <span class="col-10">{{ office.email }}</span>
          </a>
          <a
            v-if="office.webSite"
            :href="getWebsiteUrl(office.webSite)"
            target="_blank"
            class="row mt-2">
            <div class="col-2 text-center"><i class="far fa-globe pr-2"/></div>
            <span class="col-10">{{ getWebsiteText(office.webSite) }}</span>
          </a>
          <a
            v-if="office.facebook"
            :href="getWebsiteUrl(office.facebook)"
            target="_blank"
            class="row mt-2">
            <div class="col-2 text-center"><i class="fab fa-facebook-f pr-2"/></div>
            <span class="col-10">Facebook</span>
          </a>
        </div>
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import UrlHelper from '@/helpers/url-helper';

export default {
  name: 'OfficeInformation',
  mixins: [UrlHelper],
  props: {
    office: {
      type: Object,
      default: () => {},
    },
    email: {
      type: String,
      default: '',
    },
    isAlreadyExpanded: {
      type: Boolean,
      default: true,
    },
    expandable: {
      type: Boolean,
      default: false,
    },
    boldName: {
      type: Boolean,
      default: true,
    },
    hideDetail: {
      type: Boolean,
      default: false,
    },
    displayPhoneType: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expanded: this.isAlreadyExpanded,
    };
  },
  computed: {
    ...mapGetters('contactUs', ['getPhoneOnly', 'getFaxOnly']),
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.form-control-plaintext {
  display: inline;
}
.form-control-plaintext {
  width: auto;
  padding-top: 0px;
  padding-bottom: 0px;
  cursor: pointer;
}
a .form-control-plaintext {
  font-weight: bold;
  font-size: 1.6rem;
}
.filler {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  z-index: 1;
}
a {
  text-decoration: none;
}
a:hover {
  color: $primary;
}
.clickable-row {
  cursor: pointer;
}
.chevron {
  display: flex;
  align-items: center;
}

.office-information {
  overflow: hidden;
}
.slide-y-enter-active,
.slide-y-leave-active {
  transition: all 0.5s;
  max-height: 600px;
}
.slide-y-enter,
.slide-y-leave-to {
  max-height: 0;
}
@media (max-width: 375px) {
  .form-control-plaintext.phone-number,.phone-number {
    font-size: 1.1REM;
  }
}
@media (max-width: 320px) {
  .fax-number {
    font-size: 1.1REM;
  }
}
</style>
